export const style = (theme) => ({
  container: {
    padding: "2rem",
    marginBottom: "2rem",
  },
  divider: {
    margin: "1rem 0",
  },
  containerSwitch: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  buttonContainer: {
    padding: "2rem 0rem 0rem",
  },
  button: {
    marginRight: "1rem",
  },
  sessionContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "1rem 0",
  },
  formControl: {
    width: "100%",
  },
  root: {
    width: "100%",
    height: "100%",
  },
  paper: {
    padding: "1rem",
  },
  customLabelForm: {
    marginBottom: "0",
  },
  list: {
    width: "100%",
  },
  listItem: {
    margin: "15px 0",
    boxShadow:
      "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    padding: "5px",
  },
  avatar: {
    height: "100%",
    backgroundSize: "cover",
    width: "100%",
  },
});
